import { Link } from 'react-router-dom';

const NAV_LINKS: Array<{ label: string; href: string }> = [
  { label: 'Home', href: 'https://peoplegroupservices.com/' },
  { label: 'Agency', href: 'https://peoplegroupservices.com/agency/' },
  { label: 'Contractor', href: 'https://peoplegroupservices.com/contractor/' },
  { label: 'News & Insights', href: 'https://peoplegroupservices.com/news-insights/' },
  { label: 'About Us', href: 'https://peoplegroupservices.com/about-us/' },
  { label: 'Get In Touch', href: 'https://peoplegroupservices.com/contact-us/' },
];

export const NavBar = () => (
  <nav className="flex items-center justify-between bg-navy px-8 py-3">
    <Link to="/login" className="flex items-center">
      <img src="/logo.webp" alt="People Group Services" className="h-[46px] w-auto" />
    </Link>
    <div className="hidden items-center lg:flex">
      {NAV_LINKS.map(({ label, href }, i) => (
        <span key={label} className="flex items-center">
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="px-3.5 text-[11px] font-semibold uppercase tracking-[.7px] text-white/90 hover:text-teal"
          >
            {label}
          </a>
          {i < NAV_LINKS.length - 1 && <span className="text-white/25">|</span>}
        </span>
      ))}
      <a
        href="#"
        className="ml-4 rounded-[24px] border-2 border-teal px-5 py-2 text-[11px] font-extrabold uppercase tracking-wider text-teal transition-colors hover:bg-teal hover:text-navy"
      >
        Refer Now ›
      </a>
    </div>
    <button className="lg:hidden text-white text-xl" aria-label="menu">
      <i className="fas fa-bars" />
    </button>
  </nav>
);
